import { FC, ReactElement } from 'react';
import { useBoolean } from 'usehooks-ts';

import { G } from '@mobily/ts-belt';
import { Button, Dialog, DialogContent, Grid, IconButton, Toolbar } from '@mui/material';

import { useTranslation } from '../../hooks/useTranslation';
import { Lambda } from '../../types';
import { styles } from './ConfirmationPrompt.styles';
import { Close } from '../icons/Close';

export const ConfirmationPrompt: FC<{
  actionEl: Lambda<{ onClick: Lambda<unknown | void, void> }, ReactElement>;
  additionalEl?: ReactElement;
  onConfirm?: Lambda<void, void>;
  disabled?: boolean;
}> = ({ actionEl, additionalEl, onConfirm, disabled }) => {
  const { value, setFalse, setTrue } = useBoolean();
  const { t } = useTranslation();

  const handleClickAccept = () => {
    if (G.isNotNullable(onConfirm)) {
      onConfirm();
    }
    setFalse();
  };

  const handleClickCancel = () => {
    setFalse();
  };

  return (
    <>
      {actionEl({ onClick: setTrue })}
      <Dialog open={value} onClose={setFalse} PaperProps={{ sx: styles.dialog }}>
        <Toolbar sx={styles.dialogTopbar}>
          <IconButton size="large" color="inherit" onClick={setFalse}>
            <Close />
          </IconButton>
        </Toolbar>
        <DialogContent sx={styles.dialogContent}>
          {additionalEl}
          <Grid container sx={styles.dialogActionButtons}>
            <Button variant="outlined" onClick={handleClickCancel}>
              {t('general.cancel')}
            </Button>
            <Button variant="contained" onClick={handleClickAccept} disabled={disabled}>
              {t('general.accept')}
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};
